// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var escapeRegExp = function (value) { return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); };
/**
 * Returns the secret attributes a communication actually uses, meaning those
 * referenced inside a Handlebars expression such as `{{user.reference}}` or
 * `{{lookup user.attributes "reference"}}`. A name that only appears in prose
 * is not declared, so it is neither decrypted nor sent to the worker.
 */
export var getReferencedSecretAttributeNames = function (templateContents, secretAttributeNames) {
    var _a;
    var expressions = (_a = templateContents.match(/{{[^}]*}}/g)) !== null && _a !== void 0 ? _a : [];
    return secretAttributeNames.filter(function (name) {
        var reference = new RegExp("(^|[^A-Za-z0-9_-])".concat(escapeRegExp(name), "([^A-Za-z0-9_-]|$)"));
        return expressions.some(function (expression) { return reference.test(expression); });
    });
};
